import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { debug } from '../../utils/debug';
import { Loader2 } from 'lucide-react';

interface AdminRouteProps {
  children: React.ReactNode;
}

/**
 * Protected route component that checks if the user is an admin.
 * Redirects non-admins to dashboard.
 */
const AdminRoute = ({ children }: AdminRouteProps) => {
  const { currentUser, loading: authLoading, isAdmin } = useAuth();

  // Show loading while auth is loading
  if (authLoading) {
    return (
      <div className="flex items-center justify-center" style={{ minHeight: 'calc(100vh - var(--full-header-height))' }}>
        <Loader2 className="h-8 w-8 animate-spin text-teal-500" />
      </div>
    );
  }

  if (!currentUser || !isAdmin) {
    debug.log('[AdminRoute] Not admin — redirecting to dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
